import { requestService as encryptionService } from '@/utils/axios-encryption'


/**
 * Batch gets the WeighStations point status
 * 
 * @export
 * @param {Array} idArr
 * @returns
 */
export function getBatchWeighStationsStatus(idArr, callbackParams) {
  return encryptionService({
    baseURL: process.env.VUE_APP_TP_URL,
    url: '/tp/weighstations/statuses/v2',
    method: 'post',
    data: { id: idArr.join(',') }
  }, callbackParams)
}

/**
 * Batch gets the truckstops point status
 *
 * @export
 * @param {Array} idArr
 * @param {*} callbackParams
 * @returns
 */
export function getBatchTruckStopsStatus(idArr, callbackParams) {
  return encryptionService({
    baseURL: process.env.VUE_APP_TP_URL,
    url: '/tp/truckstops/statuses/v2',
    method: 'post',
    data: { id: idArr.join(',') }
  }, callbackParams)
}

/**
 * Batch gets the fuel point status
 *
 * @export
 * @param {Array} idArr
 * @param {*} callbackParams
 * @returns
 */
export function getBatchFuelPricesStatus(idArr, callbackParams) {
  return encryptionService({
    baseURL: process.env.VUE_APP_TP_URL,
    url: '/tp/places/fuel_prices/v2',
    method: 'post',
    data: { id: idArr.join(',') }
  }, callbackParams)
}

export function getCirclePoi(data, cancelToken) {
  return encryptionService({
    url: '/fleet/place/around/v2',
    method: 'post',
    data: data,
    cancelToken
  })
}

export function getCircleFacility(data, cancelToken) {
  let params = {
    latitude: data.latitude,
    longitude: data.longitude,
    radius: data.radius,
    userLatitude: data.latitude,
    userLongitude: data.longitude
  }
  return encryptionService({
    baseURL: process.env.VUE_APP_TP_URL || process.env.VUE_APP_URL,
    url: '/tp/facility/find/around/v2',
    method: 'post',
    data: params,
    cancelToken,
    noReacquire: true
  })
}

export function getRouteAsidePoi(data, cancelToken) {
  let param = {
    url: '/fleet/place/route/v2',
    method: 'post',
    data: data,
    cancelToken
  }
  return encryptionService(param)
}
